import React, { useState } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import ResponsiveDrawer from './employeeUI/ResponsiveDrawer';

const useStyles = createUseStyles((theme) => ({
  avatar: {
    height: 35,
    width: 35,
    minWidth: 35,
    borderRadius: 50,
    marginLeft: 14,
    border: `1px solid ${theme.color.lightGrayishBlue2}`,
    '@media (max-width: 768px)': {
      marginLeft: 10,
      height: 30,
      width: 30,
    },
  },
  container: {
    height: 40,
  },
  name: {
    ...theme.typography.itemTitle,
    textAlign: 'right',
    fontSize: '14px',
    '@media (max-width: 768px)': {
      fontSize: '12px',
      display: 'none', // Hide name on small screens
    },
  },
  separator: {
    borderLeft: `1px solid ${theme.color.lightGrayishBlue2}`,
    marginLeft: 32,
    marginRight: 32,
    height: 32,
    width: 2,
    '@media (max-width: 768px)': {
      marginLeft: 14,
      marginRight: 0,
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    lineHeight: '30px',
    position: 'relative',
    top: '6px',
    left: '5px',
    '@media (max-width: 1080px)': {
      fontSize: '20px',
    },
    '@media (max-width: 468px)': {
      fontSize: '18px',
    },
  },
  iconStyles: {
    cursor: 'pointer',
    marginLeft: 25,
    '@media (max-width: 768px)': {
      marginLeft: 12,
    },
  },
  navbar: {
    background: '#fff',
    height: '64px',
    position: 'fixed',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    zIndex: '1100',
    width: '100%',
    color: '#8e8e8e',
    paddingLeft: '25px',
    paddingRight: '30px',
    justifyContent:"end",
    '@media (max-width: 768px)': {
      paddingLeft: '10px',
      paddingRight: '10px',
      height: '56px',
    },
  },
  menuIcon: {
    display: 'none',
    '@media (max-width: 768px)': {
      display: 'block',
    },
  },
}));

function EmployeeUi({ isDrawerOpen, setIsDrawerOpen }) {
  const theme = useTheme();
  useStyles({ theme });
  const [sidebarVisible, setSidebarVisible] = useState(false);

  return (
    <div>
      {/* The global top header (the responsive-drawer hamburger strip) was removed
          so every employee page matches the dashboard's clean layout — the side
          rail fills to the top on all pages. The attendance status legend now
          renders inside the attendance page body instead of this strip. */}
      <ResponsiveDrawer sidebarVisible={sidebarVisible} setSidebarVisible={setSidebarVisible} />
    </div>
  );
}

export default EmployeeUi;
